import React, {useEffect, useState} from 'react'
import smsgatewayService from '../../../../services/smsgateway.service'
import {useEyeconxStore} from '../../../../store/eyeconxStore'
import {toast} from 'react-toastify';
import OverviewCards from './widgets/OverviewCards';
import DailyChart from './widgets/DailyChart';
import MonthlyChart from './widgets/MonthlyChart';
import clinicService from '../../../../services/clinic.service';
import Loading from "../../layout/Loading";

function SmsDashboard() {
    const [dashboardData, setDashboardData] = useState({})
    const [dashboardOverview, setDashboardOverview] = useState({})
    const [dailyChart, setDailyChart] = useState([])
    const [monthlyChart, setMonthlyChart] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const setClinicInfo = useEyeconxStore(state => state.setClinicInfo)
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const setSmsInbox = useEyeconxStore(state => state.setSmsInbox)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dashboardResponse = await smsgatewayService.getDashboardData(clinicId)
                console.log("Dashboard Data:", dashboardResponse.data)

                setDashboardOverview(dashboardResponse.data.overview)
                setDailyChart(dashboardResponse.data.dailyMessageChart)
                setMonthlyChart(dashboardResponse.data.monthlyMessageChart)
                setSmsInbox(parseInt(dashboardResponse.data.overview.messagesUnread))

                const clinicResponse = await clinicService.getClinicInfo(clinicId)
                setClinicInfo(clinicResponse.data)

            } catch (err) {
                toast.error("Error loading dashboard data");
                console.error("Dashboard error:", err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchData();
    }, [clinicId, setClinicInfo, setSmsInbox])

    if (isLoading) {
        return (
            <Loading/>
        )
    }

    return (
        <div className="container-fluid px-4 py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="mb-0 fw-bold fs-3">  {/* Added fs-3 for smaller font size */}
                    <i className="bi bi-speedometer2 me-2 text-primary fs-3"></i> {/* Added fs-4 to icon */}
                    SMS Dashboard
                </div>
                <div className="text-muted">
                    Clinic ID: {clinicId}
                </div>
            </div>

            {dashboardOverview && (
                <OverviewCards data={dashboardOverview} monthly={monthlyChart}/>
            )}

            <div className="row mt-4 g-4">
                {dailyChart && dailyChart.length > 0 && (
                    <div className="col-lg-8">
                        <DailyChart data={dailyChart}/>
                    </div>
                )}

                {monthlyChart && monthlyChart.length > 0 && (
                    <div className="col-lg-4">
                        <MonthlyChart data={monthlyChart}/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SmsDashboard